const contractingCorporationProfileEn = {
  boardMember: {
    noResults: 'No board members found',
    searchPlaceholder: 'Search by name or email...',
  },
  error: {
    loadingFailed: 'Failed to load data',
    unknownError: 'An unknown error occurred',
  },
  tabs: {
    boardMember: 'Board Members',
    contactPoints: 'Contact Points',
    corporateOverview: 'Corporate Overview',
    groupCompanies: 'Group Companies',
    history: 'History',
    registration: 'Registration',
    shareholders: 'Shareholders',
  },
  title: 'Contracting Corporation Profile',
  validation: {
    required: '{{field}} is required',
  },
};

export default contractingCorporationProfileEn;
